import { CardHeader, Grid, Typography } from '@mui/material'
import React from 'react'

const NB = ({texts = []}) => {
  return (
    <>
      <Grid
        m={0.5}
        border={"1px rgba(208, 11, 11, 0.25) solid "}
        boxShadow="0px 1px 2px rgba(161, 7, 7, 0.25)"
      >
        <CardHeader
          title="NB"
          titleTypographyProps={{ variant: "body1" }}
          subheaderTypographyProps={{ variant: "caption" , color: "error"}}
          subheader={
            <Grid ml={1}>
                {
                    texts.map((item,idx)=>(
                        <Typography key={idx}>{`- ${item}`}</Typography>
                    ))
                }
              
            </Grid>
          }
        />
      </Grid>
    </>
  )
}

export default NB